import Image from "next/image";

export const SortIcon = ({ dir }: { dir: 'asc' | 'desc' }) => (
  <Image
    src={dir === 'desc' ? '/tkn_lnd_pg_assets/images/icons/icon-sort-down.svg' : '/tkn_lnd_pg_assets/images/icons/icon-sort-up.svg'}
    alt="sort direction"
    width={16}
    height={16}
    style={{ display: 'inline-block', verticalAlign: 'middle' }}
    loading="lazy"
  />
);
